/* ------------------------------------------------------------------
クリックしたら該当の箇所までスクロールアニメーションをする
--------------------------------------------------------------------- */
export default function scrollToTarget(click_elm, target_elm) {
  $(document).on("click", click_elm, () => {
    const speed = 500;
    const position = $(target_elm).offset().top - 100;
    $("html, body").animate({scrollTop: position}, speed, "swing");
  });
}
